export default __webpack_public_path__ + "static/media/list_main_9_2.471505f7.jpg";